import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import packageSample from "../../Assets/marked-package.png";
import whiteSheets from "../../Assets/white-sheets.png";
import noMess from "../../Assets/no-mess.png";
import lightWeight from "../../Assets/light-weight.png";
import effectiveCleaning from "../../Assets/effective-cleaning.png";
import quickDissolve from "../../Assets/quick-dissolve.png";
import plasticFree from "../../Assets/plastic-free.png";
import Tilt from "react-parallax-tilt";
import WhyKlean from "../WhyKlean/WhyKlean";
import TextCarousel from "../TextCarousel/TextCarousel";
import BuiltForYou from "../BuiltForYou/BuiltForYou";

function Products() {
  return (
    <>
      <Container fluid className="products-section page-top-settings" id="products">
        <Container className="white">
          <Row>
            <h1>Laundry Detergent Sheets Manufacturer</h1>
            <h2 className="page-title ">
              About Our Products
              <p>The Innovation</p>
            </h2>
          </Row>
          <Row>
            <Col md={6} style={{ paddingBottom: 20 }}>
              <Tilt>
                <img
                  src={packageSample}
                  alt="laundry detergent strips manufacturer"
                  className="img-fluid"
                />
              </Tilt>
            </Col>
            <Col md={5} className="products-intro">
              <p className="products-info">
              Our detergent sheets dissolve completely in the wash—no residue, no mess. Simply toss one sheet into your machine with your laundry and enjoy a powerful, streak-free clean. Their ultra-thin, compact form factor makes them ideal for limited storage, travel kits, and brands looking to cut down on bulk packaging.
              </p>
              <p className="products-info">
              Choose from a spectrum of scents—from crisp, clean linen to bright, floral notes—or work with us to develop a signature fragrance that speaks to your brand. All formulations are free of harsh surfactants and phosphates, delivering a gentle yet effective wash every time.


              </p>
              <p className="products-info">
                Ingredients: Glycerol, Primary Alcohol Ethoxylate, Sodium Dodecyl Sulfate, Sodium Acetate Trihydrate, Protease, Polyvinyl alcohol (100% water-soluble), Deionized Water, Fragrance, Starch. <strong>All ingredients—and even the PVA content—can be adjusted to meet your exact requirements. </strong>
              </p>
            </Col>
          </Row>
        </Container>

        <Container className="products-content sheets-section my-5">
          <WhyKlean />
          <Row>
            <Col md={6} className="sheets-img">
              <figure>
                <img
                  src={whiteSheets}
                  alt="laundry detergent strips manufacturer"
                  className="img-fluid"
                />
              </figure>
            </Col>
            <Col md={6} className="products-intro sheets-intro">
              <h3>Why Our Sheets Feel Different?</h3>
              <div>We use just enough PVA to hold the sheet together—nothing more. While extra PVA gives a super-smooth look, it’s mostly cosmetic and has stirred debate in the eco space. Here’s our approach:</div>
              <ul>
                <li>Cleaning Power First: More PVA doesn’t improve cleaning. We focus on the active ingredients that actually get your clothes clean.</li>
                <li>Eco-Conscious: By keeping PVA low, we reduce unnecessary additives and waste.</li>
                <li>Built to Dissolve: Our sheets stay intact until you start the wash, then disappear completely—no residue, no fuss.</li>
                <li>Custom Finish: Prefer a slicker feel? We can boost the PVA level on request—just let us know.</li>
              </ul>
            </Col>
          </Row>
        </Container>
      </Container>
      <TextCarousel />
      <BuiltForYou />
      <Container
        fluid
        className="products-section products-details"
        id="products"
      >
        <Container className="products-content">
          <Row>
            <h2 className="products-details-title skewed">Our detergent sheets</h2>
          </Row>

          <Row className="feature-wrapper">
            <Col xs={6} md={2} className="">
              <img src={noMess} className="feature-img" alt="laundry detergent strips manufacturer" />
            </Col>

            <Col xs={6} md={2} className="">
              <img
                src={lightWeight}
                className="feature-img"
                alt="laundry detergent strips manufacturer"
              />
            </Col>

            <Col xs={6} md={2} className="">
              <img
                src={effectiveCleaning}
                className="feature-img"
                alt="laundry detergent strips manufacturer"
              />
            </Col>

            <Col xs={6} md={2} className="">
              <img
                src={quickDissolve}
                className="feature-img"
                alt="laundry detergent strips manufacturer"
              />
            </Col>

            <Col xs={6} md={2} className="">
              <img
                src={plasticFree}
                className="feature-img"
                alt="laundry detergent strips manufacturer"
              />
            </Col>
          </Row>

          <Row className="products-details-text text-center">
            <Col md={12} className="products-intro">
              <p className="products-info">
                Our detergent sheets represent a potent, ultra-concentrated
                solution that empowers us to address critical environmental
                concerns. By eliminating plastic usage, conserving water, and
                mitigating the transportation of heavy oil-laden products, we
                contribute significantly to a greener future while optimizing
                space and reducing waste.
              </p>

              <p className="products-info">
                We offer comprehensive private label solutions, too. Development
                process from design, formula development to shelf-ready
                packaging.
              </p>
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  );
}

export default Products;
